<template>
  <v-card>
    <v-progress-linear
      indeterminate
      absolute
      top
      color="primary"
      :active="loading"
    />

    <v-card-title>
      {{ item ? `${ item.name }: редактирование` : 'Тег: создание' }}
    </v-card-title>

    <v-card-text>
      <v-form ref="form" lazy-validation>
        <v-text-field
          v-model="form.name"
          autofocus
          label="Название тега"
          type="text"
          :rules="rules.name"
          :disabled="loading"
        />
      </v-form>
    </v-card-text>

    <v-card-actions class="px-6">
      <v-btn
        text
        color="success"
        :disabled="loading || !submittable"
        @click.prevent="onSubmit"
      >
        {{ !!item ? 'Обновить' : 'Создать' }}
      </v-btn>

      <v-btn
        v-if="item"
        v-permission="['tag-delete']"
        color="error"
        text
        :disabled="loading"
        @click.prevent="$emit('onRemove', item)"
      >
        Удалить
      </v-btn>

      <div class="flex-grow-1" />

      <v-btn
        color="grey darken-1"
        text
        :disabled="loading"
        @click="$emit('close')"
      >
        Отмена
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import { mapActions } from 'vuex';

export default {
  name: 'tag-edit-form',

  props: {
    loading: {
      type: Boolean,
      default: false,
    },

    item: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      form: {
        name: this.item?.name || '',
      },

      rules: {
        name: [v => !!v || 'Поле обязательно для заполнения'],
      },
    };
  },

  computed: {
    submittable() {
      return this.item?.name !== this.form.name;
    },
  },

  methods: {
    ...mapActions(['showNotify']),
    ...mapActions('tags', ['getItem', 'create', 'update', 'refreshList']),

    onSubmit() {
      if (!this.$refs.form.validate()) return;

      this.$emit('onSubmit', {
        id: this.item?.id ?? null,
        name: this.form.name,
      });
    },
  },

};

</script>
